"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1086],{

/***/ 75195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ CountdownSimple; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_countdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98130);
/* harmony import */ var _versumstudios_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33498);



var CountdownSimple = function(param) {
    var auctionEnd = param.auctionEnd;
    var renderer = function(props) {
        var formatted = props.formatted, completed = props.completed;
        var days = formatted.days, hours = formatted.hours, minutes = formatted.minutes, seconds = formatted.seconds;
        if (completed) {
            // TODO: decide what to do when bidding finish
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_versumstudios_ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                unset: true,
                css: {
                    color: "$secondaryFill"
                },
                children: "This auction has ended"
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_versumstudios_ui__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
            unset: true,
            css: {
                color: "$secondaryFill",
                fontSize: 14,
                fontFamily: "$mono"
            },
            children: [
                days !== "00" && "".concat(days, "d"),
                " ",
                hours,
                "h ",
                minutes,
                "m ",
                seconds,
                "s"
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_versumstudios_ui__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        css: {
            display: "flex",
            flexDirection: "column"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            date: auctionEnd,
            renderer: renderer,
            onComplete: function() {
            // TODO: bidding ended. Do something
            }
        })
    });
};


/***/ }),

/***/ 1086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ SmartGridToken; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/use-intl.esm3.js + 18 modules
var use_intl_esm3 = __webpack_require__(72439);
// EXTERNAL MODULE: ./node_modules/next-use-contextual-routing/dist/index.esm.js
var index_esm = __webpack_require__(30221);
// EXTERNAL MODULE: ./node_modules/swr/infinite/dist/index.mjs
var dist = __webpack_require__(44593);
// EXTERNAL MODULE: ./src/components/countdown-simple/index.tsx
var countdown_simple = __webpack_require__(75195);
// EXTERNAL MODULE: ./src/components/creators/index.tsx + 1 modules
var creators = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/containers/contextual-token-modal/index.tsx + 3 modules
var contextual_token_modal = __webpack_require__(17226);
// EXTERNAL MODULE: ./src/utils/fetcher.ts
var fetcher = __webpack_require__(79618);
// EXTERNAL MODULE: ./src/utils/market.tsx
var utils_market = __webpack_require__(93650);
// EXTERNAL MODULE: ./src/utils/use-media.ts
var use_media = __webpack_require__(46873);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/smart-grid-token/styles.ts

var VerticalContainer = (0,stitches/* styled */.zo)("div", {
    width: "100vw",
    marginBottom: "$2",
    "@bp1": {
        width: "50vw",
        margin: "0 auto"
    },
    "@bp2": {
        width: "718px"
    },
    "& > *": {
        display: "block",
        marginBottom: "$2"
    }
});

;// CONCATENATED MODULE: ./src/components/smart-grid-token/index.tsx




/* eslint-disable no-console */ /* eslint-disable react/display-name */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable react-hooks/exhaustive-deps */ // import { dequal } from 'dequal';
















var MediaWrapper = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4824), __webpack_require__.e(9645), __webpack_require__.e(9943), __webpack_require__.e(2278)]).then(__webpack_require__.bind(__webpack_require__, 33754));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33754)
            ];
        }
    },
    ssr: false
});
var Grid = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5151).then(__webpack_require__.bind(__webpack_require__, 75151));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75151)
            ];
        }
    },
    ssr: false
});
var SmartGridToken = function(param) {
    var api = param.api, query = param.query, limit = param.limit, layout = param.layout, info = param.info, market = param.market, labels = param.labels, _nodata = param.nodata, nodata = _nodata === void 0 ? "No data to display" : _nodata, maxtime = param.maxtime, sorting = param.sorting;
    var ref;
    var t = (0,use_intl_esm3/* default */.Z)("common");
    var ref1 = (0,index_esm/* useContextualRouting */.K)(), makeContextualHref = ref1.makeContextualHref, returnHref = ref1.returnHref;
    var ref2 = (0,react.useState)(-1), index = ref2[0], setIndex = ref2[1];
    var router = (0,next_router.useRouter)();
    var masonry = (0,use_media/* useMedia */.G)([
        "(min-width: 1440px)",
        "(min-width: 640px)"
    ], [
        5,
        3
    ], 2);
    var grid = (0,use_media/* useMedia */.G)([
        "(min-width: 1440px)",
        "(min-width: 640px)"
    ], [
        8,
        4
    ], 2);
    var space = (0,use_media/* useMedia */.G)([
        "(min-width: 1440px)",
        "(min-width: 640px)"
    ], [
        "32px",
        "16px"
    ], "0px");
    var getKey = function(pageIndex, previousPageData) {
        if (previousPageData && !previousPageData.length) return null; // reached the end
        // merge all query parameters
        var queryParams = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query, sorting && {
            sorting: sorting
        }), {
            offset: (pageIndex + 0) * limit
        }), maxtime && {
            maxtime: maxtime
        });
        var test = "".concat(api, "?").concat(new URLSearchParams(queryParams).toString());
        return test;
    };
    var ref3 = (0,dist/* default */.ZP)(getKey, fetcher/* tokensFetcher */.WR, {
        revalidateIfStale: false,
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshInterval: 0,
        persistSize: true
    }), data = ref3.data, error = ref3.error, size = ref3.size, setSize = ref3.setSize, isValidating = ref3.isValidating;
    var ref4 = (0,react.useState)([]), items = ref4[0], setItems = ref4[1];
    (0,react.useEffect)(function() {
        var _instance;
        // don't update items if we are in contextual item modal and we already have items loaded
        if (router.query.tokenId && items.length !== 0) return;
        setItems(data ? (_instance = []).concat.apply(_instance, (0,_to_consumable_array/* default */.Z)(data)) : []);
    }, [
        data
    ]);
    var isLoadingInitialData = !data && !error;
    var isLoadingMore = isLoadingInitialData || size > 0 && data && typeof data[size - 1] === "undefined";
    var isEmpty = data && data.length === 0;
    var isReachingEnd = isEmpty || data && ((ref = data[data.length - 1]) === null || ref === void 0 ? void 0 : ref.length) < limit;
    var isRefreshing = isValidating && data && data.length === size;
    var modalChange = function(increment) {
        // only allow keyboard navigation if its coming from a smart-grid-token component
        if (router.query.tokenId) {
            var next = index + increment;
            if (next >= 0 && next < items.length) {
                var token = items[next];
                router.push(makeContextualHref({
                    tokenId: token.id
                }), "/token/".concat(token.contract.name, "/").concat(token.token_id), {
                    scroll: false,
                    shallow: true,
                    locale: router.locale
                });
            }
        }
    };
    var modalClose = function() {
        router.push(returnHref, undefined, {
            scroll: false,
            shallow: true,
            locale: router.locale
        });
    };
    var renderThumbnail = function(token) {
        var ref, ref1, ref2, ref3, ref4;
        var hasBidder = token.prio_auction && token.prio_auction.length > 0 ? (ref = token.prio_auction[0]) === null || ref === void 0 ? void 0 : ref.current_bidder : false;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                overflow: "hidden"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    scroll: false,
                    shallow: true,
                    href: makeContextualHref({
                        tokenId: token.id
                    }),
                    as: "/token/".concat(token.contract.name, "/").concat(token.token_id),
                    locale: router.locale,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaWrapper, {
                            token: token,
                            inDetailView: false,
                            labels: labels,
                            square: layout === constants/* FEED_LAYOUT.GRID */.Gf.GRID
                        })
                    })
                }),
                (info || market) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                    css: (0,_object_spread/* default */.Z)({
                        flexDirection: "column"
                    }, market && {
                        borderBottomLeftRadius: 5,
                        borderBottomRightRadius: 5,
                        backgroundColor: "$secondaryBackground",
                        border: "1px solid $colors$primaryBorder",
                        borderTop: "1px solid transparent"
                    }),
                    children: [
                        info && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            css: {
                                justifyContent: "space-between",
                                margin: "$space$4"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                css: {
                                    flexDirection: "column",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                        unset: true,
                                        ellipsis: true,
                                        css: {
                                            fontWeight: 700,
                                            overflow: "hidden"
                                        },
                                        children: token.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(creators/* Creators */.y, {
                                        creators: token.creators
                                    })
                                ]
                            })
                        }),
                        info && market && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            css: {
                                borderTop: "1px solid $colors$primaryBorder"
                            }
                        }),
                        market && token.prio_auction && token.prio_auction.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                flexDirection: "column",
                                margin: "$space$4"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                    css: {
                                        justifyContent: "space-between"
                                    },
                                    vertical: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            ellipsis: true,
                                            css: {
                                                color: "$secondaryFill",
                                                overflow: "hidden",
                                                fontSize: 14
                                            },
                                            children: "Supply"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            ellipsis: true,
                                            css: {
                                                color: "$secondaryFill",
                                                overflow: "hidden",
                                                fontSize: 14
                                            },
                                            children: "Price"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                    css: {
                                        justifyContent: "space-between"
                                    },
                                    vertical: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                                            unset: true,
                                            css: {
                                                color: "$primaryFill",
                                                fontSize: 14
                                            },
                                            children: [
                                                "x ",
                                                token.supply
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            ellipsis: true,
                                            css: {
                                                color: "$primaryFill",
                                                overflow: "hidden",
                                                fontSize: 14
                                            },
                                            children: token.prio_swap && token.prio_swap.length > 0 ? (0,utils_market/* getCurrencyJSX */.J)(((ref1 = token.prio_swap[0]) === null || ref1 === void 0 ? void 0 : ref1.current_price) || 0, (ref2 = token.prio_swap[0]) === null || ref2 === void 0 ? void 0 : ref2.currency) : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        market && token.prio_auction && token.prio_auction.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                flexDirection: "column",
                                margin: "$space$4"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                    css: {
                                        justifyContent: "space-between"
                                    },
                                    vertical: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            ellipsis: true,
                                            css: {
                                                color: "$secondaryFill",
                                                overflow: "hidden",
                                                fontSize: 14
                                            },
                                            children: hasBidder ? "Current bid" : "Reserve"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            ellipsis: true,
                                            css: {
                                                color: "$secondaryFill",
                                                overflow: "hidden",
                                                fontSize: 14
                                            },
                                            children: "Ending in"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                    css: {
                                        justifyContent: "space-between"
                                    },
                                    vertical: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            css: {
                                                color: "$primaryFill",
                                                fontSize: 14
                                            },
                                            children: (0,utils_market/* getCurrencyJSX */.J)((ref3 = token.prio_auction[0]) === null || ref3 === void 0 ? void 0 : ref3.current_bid, token.prio_auction[0].currency)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(countdown_simple/* CountdownSimple */.M, {
                                            auctionEnd: new Date((ref4 = token.prio_auction[0]) === null || ref4 === void 0 ? void 0 : ref4.end_time).getTime()
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }, token.id);
    };
    (0,react.useEffect)(function() {
        var nextIndex = items.findIndex(function(e) {
            return String(e.id) === router.query.tokenId;
        });
        if (nextIndex !== index) {
            setIndex(nextIndex);
        }
    }, [
        items,
        router.query.tokenId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            !isLoadingInitialData && items.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Container */.W2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                    unset: true,
                    css: {
                        color: "$secondaryFill"
                    },
                    children: nodata
                })
            }),
            layout === constants/* FEED_LAYOUT.MASONRY */.Gf.MASONRY && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                columns: masonry,
                space: space,
                children: items.map(function(token) {
                    return renderThumbnail(token);
                })
            }),
            layout === constants/* FEED_LAYOUT.GRID */.Gf.GRID && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                columns: grid,
                space: space,
                children: items.map(function(token) {
                    return renderThumbnail(token);
                })
            }),
            layout === constants/* FEED_LAYOUT.VERTICAL */.Gf.VERTICAL && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalContainer, {
                children: items.map(function(token) {
                    return renderThumbnail(token);
                })
            }),
            !isReachingEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                css: {
                    padding: "$1 0"
                },
                horizontal: true,
                children: isLoadingMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                    progress: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    onClick: function() {
                        return setSize(size + 1);
                    },
                    variant: "secondary",
                    disabled: isRefreshing,
                    children: t("load-more")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contextual_token_modal/* ContextualTokenModal */.Y, {
                visible: !!router.query.tokenId,
                token: items[index],
                onChange: modalChange,
                onClose: modalClose
            })
        ]
    });
};


/***/ }),

/***/ 17226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ ContextualTokenModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/modal-help/styles.ts

var Container = (0,stitches/* styled */.zo)("div", {
    display: "none",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "$primaryBackground",
    zIndex: 1,
    "@bp1": {
        display: "flex",
        padding: "$space$2"
    }
});
var Key = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "$space$5"
});

;// CONCATENATED MODULE: ./src/components/modal-help/index.tsx


var modal_help_Key = function(param) {
    var icon = param.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Key, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("kbd", {
            children: icon
        })
    });
};
function ModalHelp() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_help_Key, {
                icon: "esc"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_help_Key, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: "chevron_left"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_help_Key, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    children: "chevron_right"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/containers/container-token/index.tsx + 27 modules
var container_token = __webpack_require__(34503);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.module.js
var index_module = __webpack_require__(51528);
;// CONCATENATED MODULE: ./src/containers/contextual-token-modal/styles.ts

var fadeIn = (0,stitches/* keyframes */.F4)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var fadeOut = (0,stitches/* keyframes */.F4)({
    from: {
        opacity: 1
    },
    to: {
        opacity: 0
    }
});
var Overlay = (0,stitches/* styled */.zo)("div", {
    backgroundColor: "hsl(0 0% 0% / 0.5439)",
    position: "fixed",
    top: 0,
    inset: 0,
    zIndex: 1000,
    "@media (prefers-reduced-motion: no-preference)": {
        animation: "".concat(fadeIn, " 200ms ease-out")
    }
});
var Close = (0,stitches/* styled */.zo)("button", {
    position: "fixed",
    top: "$space$3",
    right: "$space$3",
    width: 32,
    height: 32,
    cursor: "pointer",
    background: "transparent",
    border: 0,
    zIndex: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@bp1": {
        right: "$space$2"
    },
    "@bp2": {
        right: "$space$1"
    },
    "&:before": {
        content: "''",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: 9999,
        backgroundColor: "$primaryBackground",
        opacity: 0.3,
        zIndex: -1
    },
    i: {
        color: "$secondaryFill"
    },
    "&:hover": {
        i: {
            color: "$primaryFill"
        }
    },
    "&:focus": {
        outline: 0,
        i: {
            color: "$primaryFill"
        }
    }
});
var Content = (0,stitches/* styled */.zo)("div", {
    width: "100vw",
    height: "100vh",
    backgroundColor: "$primaryBackground",
    "&:focus": {
        outline: "none"
    },
    "@media (prefers-reduced-motion: no-preference)": {
        animation: "".concat(fadeIn, " 200ms ease-out"),
        '&[data-state="closed"]': {
            animation: "".concat(fadeOut, " 100ms ease-out")
        }
    }
});
var Scrollable = (0,stitches/* styled */.zo)("div", {
    overflowY: "auto"
});
var styles_Container = (0,stitches/* styled */.zo)("div", {
    width: "100vw",
    height: "calc(100vh - $space$1)",
    marginTop: "$space$1"
});

;// CONCATENATED MODULE: ./src/containers/contextual-token-modal/index.tsx






var ContextualTokenModal = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, token = param.token, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {
        return null;
    } : _onChange, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {
        return null;
    } : _onClose;
    var handleKey = function(e) {
        if (e.key === "ArrowLeft") {
            onChange(-1);
        }
        if (e.key === "ArrowRight") {
            onChange(+1);
        }
    };
    (0,react.useEffect)(function() {
        if (visible) {
            // document.body.style.overflow = 'hidden';
            document.body.classList.add("lock");
        } else {
            // document.body.style.overflow = 'unset';
            document.body.classList.remove("lock");
        }
    }, [
        visible
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("keyup", handleKey);
        return function() {
            window.removeEventListener("keyup", handleKey);
        };
    });
    if (!token) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Root */.fC, {
        open: visible,
        onOpenChange: onClose,
        allowPinchZoom: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Portal */.h_, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Overlay */.aV, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Content */.VY, {
                        asChild: true,
                        onPointerDownOutside: function(e) {
                            return e.preventDefault();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Close */.x8, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            children: "close"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Scrollable, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(container_token/* ContainerToken */._, {
                                                token: token
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHelp, {})
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 79618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ collectionsFetcher; },
/* harmony export */   "Jy": function() { return /* binding */ auctionsFetcher; },
/* harmony export */   "On": function() { return /* binding */ boardsFetcher; },
/* harmony export */   "T7": function() { return /* binding */ swapsFetcher; },
/* harmony export */   "WR": function() { return /* binding */ tokensFetcher; }
/* harmony export */ });
/* unused harmony export fetcher */
var fetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    });
};
var tokensFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.tokens;
    });
};
var boardsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.token_lists;
    });
};
var collectionsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e.collections;
    });
};
var auctionsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e;
    });
};
var swapsFetcher = function(url) {
    return fetch(url).then(function(res) {
        return res.json();
    }).then(function(e) {
        return e;
    });
};


/***/ })

}]);